export const API_URL = "https://verify.booktable.co.in/";
export const IDP_URL = "https://admin.booktable.co.in/api/";
// export const API_URL = "http://localhost:3000/";
// export const IDP_URL = "http://localhost:3010/api/";